"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Proposez-vous des abonnements ?",
  answer: "Nous proposons des solutions adaptées selon votre consommation."
}, {
  question: "La machine est-elle offerte ?",
  answer: "Oui, selon le volume de commande."
}, {
  question: "Livrez-vous à Dakar ?",
  answer: "Oui, avec conditions selon le montant."
}];
export default function FaqTransparenceDesPrix() {
  return <section data-section-id="80540" id="mini-faq" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground mb-4 tracking-tight">
            Questions Fréquentes
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">Découvrez les réponses aux questions les plus fréquentes sur nos offres entreprises, la livraison et nos solutions café à Dakar et Thiès.</p>
        </div>

        <div className="bg-transparent rounded-none border-none shadow-none p-4 md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`faq-${i}`} data-index={i}>
                <AccordionTrigger className="text-left text-[20px] font-serif font-semibold text-foreground hover:text-ring transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pt-2 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}